import { Modal } from 'common/modal';
import styles from './legacy-video-modal.module.scss';

type VideoModalProps = {
  onClose: () => void;
};

const LegacyVideoModal: React.FC<VideoModalProps> = ({ onClose }) => (
  <Modal
    onClose={onClose}
    disableManualClosing
    closeOnOutsideClick
    contentClassName={styles.contentModal}
  >
    <div className={styles.videoWrapper}>
      <iframe
        id="player"
        frameBorder="0"
        title="Personal Legacy Animation"
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        src="https://www.youtube.com/embed/1nvhLHG4aMo"
      />
    </div>
  </Modal>
);

export { LegacyVideoModal };
